"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminEntityIdParams = exports.AdminUpdateCompanyRegionRequest = exports.ExtendTrialRequest = exports.AdminPaginatedQuery = exports.UpdateInternalUserRequest = exports.CreateInternalUserRequest = exports.AdminSearchQuery = exports.AdminConfirmForgotPasswordRequest = exports.AdminForgotPasswordRequest = exports.AdminNewPasswordRequest = exports.AdminSignInRequest = exports.AdminAuditTargetType = exports.AdminAuditAction = exports.AdminRoleSchema = void 0;
const zod_1 = require("zod");
const region_types_1 = require("./region.types");
const companies_types_1 = require("./companies.types");
// --- Enums ---
exports.AdminRoleSchema = zod_1.z.enum(['SUPER_ADMIN', 'SUPPORT', 'VIEWER']);
exports.AdminAuditAction = zod_1.z.enum([
    'ADMIN_CREATED',
    'ROLE_CHANGED',
    'ADMIN_DEACTIVATED',
    'ADMIN_REACTIVATED',
    'USER_PASSWORD_RESET',
    'USER_LOCKED',
    'USER_UNLOCKED',
    'TRIAL_EXTENDED',
    'COMPANY_REGION_UPDATED',
]);
exports.AdminAuditTargetType = zod_1.z.enum(['AdminUser', 'User', 'Company']);
// --- Auth ---
exports.AdminSignInRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(1),
});
exports.AdminNewPasswordRequest = zod_1.z.object({
    session: zod_1.z.string().min(1),
    userIdForSrp: zod_1.z.string().min(1),
    newPassword: zod_1.z.string().min(8),
});
exports.AdminForgotPasswordRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
});
exports.AdminConfirmForgotPasswordRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
    code: zod_1.z.string().min(1),
    newPassword: zod_1.z.string().min(8),
});
// --- Internal user management ---
exports.AdminSearchQuery = zod_1.z.object({
    search: zod_1.z.string().optional(),
});
exports.CreateInternalUserRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    role: exports.AdminRoleSchema,
    temporaryPassword: zod_1.z.string().min(8),
});
exports.UpdateInternalUserRequest = zod_1.z.object({
    role: exports.AdminRoleSchema.optional(),
    active: zod_1.z.boolean().optional(),
});
// --- Paginated queries ---
exports.AdminPaginatedQuery = zod_1.z.object({
    search: zod_1.z.string().optional(),
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(100).default(20),
});
// --- Company ---
exports.ExtendTrialRequest = zod_1.z.object({
    endDate: zod_1.z.string().min(1),
});
exports.AdminUpdateCompanyRegionRequest = zod_1.z.object({
    country: region_types_1.CountryCodeSchema,
    nationalIdentifierType: companies_types_1.NationalIdentifierTypeSchema,
    nationalIdentifier: zod_1.z.string(),
});
// --- Params ---
exports.AdminEntityIdParams = zod_1.z.object({
    id: zod_1.z.string().min(1),
});
